module.exports = __webpack_public_path__ + "static/img/fire.51a00d14.png";